// /components/GameModal.js
import React from 'react';

const GameModal = ({ isOpen, onClose, children }) => {
    if (!isOpen) return null;

    return (
        <div
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                background: 'rgba(0,0,0,0.8)',
                backdropFilter: 'blur(6px)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 9999,
                padding: '1rem',
            }}
        >
            <div
                style={{
                    background: 'rgba(17,25,40,0.95)',
                    border: '1px solid rgba(255,255,255,0.15)',
                    borderRadius: '1rem',
                    boxShadow: '0 0 25px rgba(0,255,200,0.2)',
                    padding: '1.5rem',
                    maxWidth: '600px',
                    width: '100%',
                    maxHeight: '80vh',
                    overflowY: 'auto',
                    position: 'relative',
                    color: '#e2e8f0'
                }}
            >
                <button
                    onClick={onClose}
                    style={{
                        position: 'absolute',
                        top: '10px',
                        right: '15px',
                        background: 'none',
                        border: 'none',
                        color: '#fff',
                        fontSize: '1.4rem',
                        cursor: 'pointer',
                    }}
                >
                    <i className="fas fa-times"></i>
                </button>
                {children}
            </div>
        </div>
    );
};

export default GameModal;
